import React from 'react';

import bem from '../../../../../utils/bem';
import type { CreativesBuilderValues } from '../../types';
import { CreativeFooterStyling } from '../CreativeFooterStyling';
import CreativeReviewAlertAsset2 from './CreativeReviewAlertAsset2/CreativeReviewAlertAsset2';
import type { CreativeFooterAsset, LineItemData } from './types';

export type CreativeFooterProps = {
  assets: CreativeFooterAsset[];
  creative: CreativesBuilderValues;
  isLoading?: boolean;
  rightSideComponent?: React.JSX.Element | React.JSX.Element[];
  hasHrLine?: boolean;
  isCreativeFooterHidden?: boolean;
  lineItemData: LineItemData;
};

const creativeFooterElement = bem('creative-footer')[1];

export const CreativeFooter = ({
  assets,
  creative,
  isLoading,
  rightSideComponent,
  hasHrLine = true,
  isCreativeFooterHidden = false,
  lineItemData,
}: CreativeFooterProps): React.JSX.Element => {
  // By default, isCreativeFooterHidden is false.
  // For VAST Video, Brightline, Innovid, and DXC creatives, the footer remains visible.
  // For other creative types, the parent component may control its visibility.
  if (isCreativeFooterHidden) return <></>;

  return (
    <CreativeFooterStyling>
      {hasHrLine && <hr />}
      <div className={creativeFooterElement('split-info-wrapper')}>
        <div className={creativeFooterElement('content', 'information')}>
          <CreativeReviewAlertAsset2
            lineItemData={lineItemData}
            assets={assets}
            creative={creative}
            isLoading={isLoading}
          />
        </div>
        <div className={creativeFooterElement('content', 'interaction')}>{rightSideComponent}</div>
      </div>
    </CreativeFooterStyling>
  );
};
